module.exports = __webpack_public_path__ + "static/pregnancy_arabic-03-6a1d743a970ee36fb19780b4c919bb5b.png";